<template>
  <div class="learning">
    <div class="banner">
      <div class="publick learningcenter">
        <div class="img fl"><img :src="info.avatar" width="105" height="105" alt=""></div>
        <div class="teacher fl">
          <h5>{{info.username}}</h5>
          <p class="p1">在教课程：{{info.level_name}}</p>
          <p class="p2">所属学校：{{info.school_name}}</p>
        </div>
        <div class="timer fr">
          <div class="time fl">
            <p>学习时长</p>
            <p>
              <span class="num">{{info.study_time}}</span>
              小时
            </p>
          </div>
          <div class="line fl"></div>
          <div class="course fl">
            <p>加入课程</p>
            <p>{{info.join_num}}</p>
          </div>
          <div class="line fl"></div>
          <div class="integral fl">
            <p>我的积分</p>
            <p>{{info.points}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="category">
      <ul>
        <li @click="category(0)" :class="categoryIndex === 0 ? 'choice':'' ">我的任务<span></span></li>
        <li @click="category(1)" :class="categoryIndex === 1 ? 'choice':'' ">我的课程库<span></span></li>
        <li @click="category(2)" :class="categoryIndex === 2 ? 'choice':'' ">我的预约<span></span></li>
      </ul>
    </div>
    <div class="Show">
      <task v-if="categoryIndex === 0"></task>
      <course v-if="categoryIndex === 1"></course>
      <live v-if="categoryIndex === 2"></live>
    </div>
    <layerRight></layerRight>
  </div>
</template>

<script>
  import task from '@/components/learning/task/task'
  import course from '@/components/learning/course/course'
  import live from '@/components/learning/live/live'
  import layerRight from '@/components/layerRight/layerRight'

  export default {
    components: {
      task,
      layerRight,
      course,
      live
    },
    data () {
      return {
        categoryIndex: 0,
        info: {}
      }
    },
    created () {
      this.getData()
    },
    methods: {
      category (index) {
        this.categoryIndex = index
      },
      getData () {
        this.$http.post('/apipx/Teacher/info', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res.data
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .learning {

    .banner {
      width: 100%;
      height: 350px;
      background: url("banner.jpg") no-repeat center center;
      overflow: hidden;

      .learningcenter {
        height: 107px;
        overflow: hidden;
        margin: 116.5px auto 0;

        .img {
          width: 107px;
          height: 107px;

          img {
            border-radius: 50%;
            border: 2px solid #fc968e;
          }
        }

        .teacher {
          margin: 0 0 0 30px;
          height: 107px;
          color: #fff;

          h5 {
            font-size: 24px;
            margin: 8px 0 0 0;
          }

          .p1 {
            margin: 10px 0 0 0;
          }

          .p2 {
            margin: 5px 0 0 0;
          }
        }

        .timer {
          width: 422px;
          height: 107px;
          color: #fff;
          text-align: center;

          .line {
            width: 1px;
            height: 20px;
            background-color: #fdb5af;
            margin: 45px 0 0 0;
          }

          .time {
            width: 140px;

            p:first-child {
              font-size: 14px;
              margin-top: 25px;
            }

            p:last-child {
              margin-top: 13px;
              font-size: 16px;

              .num {
                font-weight: bold;
              }
            }
          }

          .course {
            width: 140px;

            p:first-child {
              font-size: 14px;
              margin-top: 25px;
            }

            p:last-child {
              margin-top: 13px;
              font-weight: bold;
              font-size: 16px;
            }
          }

          .integral {
            width: 140px;

            p:first-child {
              font-size: 14px;
              margin-top: 25px;
            }

            p:last-child {
              margin-top: 13px;
              font-weight: bold;
              font-size: 16px;
            }
          }
        }
      }
    }

    .category {
      width: 100%;
      height: 100px;
      box-shadow: 0px 20px 20px #f5f5f5;
      overflow: hidden;

      ul {
        width: 600px;
        margin: 0 auto;
        height: 100px;

        li {
          width: 200px;
          height: 100px;
          line-height: 100px;
          float: left;
          position: relative;
          text-align: center;
          font-size: 16px;
          cursor: pointer;

          &.choice {
            color: #ff8484;

            span {
              background-color: #ff8484;
            }
          }

          span {
            display: block;
            width: 20px;
            height: 3px;
            background-color: #fff;
            position: absolute;
            left: 50%;
            bottom: 0;
            margin: 0 0 0 -10px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/learning/learning.vue